import { BoxProps, Flex, Link, NavLink } from 'theme-ui'
import { MouseEvent } from 'react'
import { AdminUserData } from 'types'
import { Heading, RouterLink, Search } from 'components'
import { noop } from 'utils'
import { NavTemplate } from './NavTemplate'
import { NavMenu } from './NavMenu'
import { useHistory, useLocation } from 'react-router-dom'
import { useConfig } from 'providers'
import { CreateStudentBtn } from './CreateStudentBtn'
import { CreateTeacherBtn } from './CreateTeacherBtn'

export type NavProps = BoxProps & {
  profile?: AdminUserData | undefined | null
  access?: {
    createStudent: boolean
    createTeacher: boolean
    viewHelpCenter: boolean
  }
  onLogoutClick?: () => void
}

type LocationState = {
  created: string
  updated: any
}

export function Nav({
  profile,
  onLogoutClick = noop,
  access,
  ...rest
}: NavProps) {
  const history = useHistory()
  const config = useConfig()
  const location = useLocation<LocationState>()

  function handleLogoutClick(e: MouseEvent<any>) {
    e.preventDefault()
    onLogoutClick()
  }
  const handleCreateStudentClick = () => {
    history.push({
      pathname: '/student/new',
      state: {
        create: location,
        config,
      },
    })
  }
  const handleCreateTeacherClick = () => {
    history.push({
      pathname: '/teacher/new',
      state: {
        create: location,
        config,
      },
    })
  }
  return (
    <NavTemplate
      Heading={
        <RouterLink to="/">
          <Heading as="h1" variant="text.logo">
            TM App Admin Dashboard
          </Heading>
        </RouterLink>
      }
      Search={profile ? <Search /> : null}
      Content={
        profile ? (
          <Flex
            sx={{
              justifyContent: ['end', 'space-around'],
              width: '100%',
            }}>
            <Search />
            {access?.createTeacher && (
              <CreateTeacherBtn
                handleCreateTeacherClick={handleCreateTeacherClick}
              />
            )}
            {access?.createStudent && (
              <CreateStudentBtn
                handleCreateStudentClick={handleCreateStudentClick}
              />
            )}

            <NavMenu
              Content={
                <>
                  <Heading variant="text.h2" sx={{ mb: 40 }}>
                    {profile.forename ?? ''}
                  </Heading>
                  <RouterLink
                    id="profile-link"
                    to={`/profile`}
                    variant="links.nav">
                    My Profile
                  </RouterLink>
                  {access?.viewHelpCenter && (
                    <RouterLink
                      id="help-center-link"
                      to="/help"
                      target="_blank"
                      variant="links.nav">
                      Teacher help center
                    </RouterLink>
                  )}

                  <NavLink
                    id="public-help-center-link"
                    href="https://help.tm.community"
                    target="_blank"
                    variant="links.nav">
                    Public help center
                  </NavLink>
                  <RouterLink
                    id="logout-link"
                    to="#"
                    variant="links.nav"
                    onClick={handleLogoutClick}
                    data-cy="logout-button">
                    Logout
                  </RouterLink>
                </>
              }
              Footer={
                <>
                  <Flex sx={{ justifyContent: 'space-between', pb: 2 }}>
                    <Link
                      href="https://www.maharishi.foundation/privacy-policy"
                      variant="links.footer"
                      target="_blank">
                      Privacy Policy
                    </Link>
                    <Link
                      href="https://www.maharishi.foundation/terms-of-service"
                      variant="links.footer"
                      target="_blank"
                      sx={{ pl: 4 }}>
                      Terms of Service
                    </Link>
                  </Flex>
                  <Flex variant="links.footer">
                    v{process.env.REACT_APP_VERSION}
                  </Flex>
                </>
              }
            />
          </Flex>
        ) : null
      }
      {...rest}
    />
  )
}
